import React, { useState } from "react";
import { Box } from "@mui/material";
import CustomButton from "../../Components/common/Button";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import TextField from "../../Components/common/TextField";
import { checkPrivileges } from "../../Helpers";
import { useSelector } from "react-redux";

const MainProcessInvoices = ({ translate, handleHeaderSearch }) => {
  const themecolors=useSelector((state)=>state.themecolors)
  const [searchValues, setSearchValues] = useState({
    poNumber: "",
    poRefNumber: ""
  })
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { key: "", label: "saleOrder" },
    { key: "individual", label: "individualDn" },
  ];
  const handleSearchValues = (name, e) => {
    setSearchValues((prevState) => ({
      ...prevState,
      [name]: e.target.value
    }))
  }

  const submitSearch = () => {
    handleHeaderSearch({
      poNumber: searchValues.poNumber,
      poRefNumber: searchValues.poRefNumber
    })
  }
  let currentPath = location.pathname.replace("/process-invoices", "");
  if (currentPath.startsWith("/")) currentPath = currentPath.slice(1);
  if (currentPath === "" || currentPath === "/") currentPath = "";

  const hideParent = currentPath === "view";
  const isIndividual = currentPath === "individual"

  return (
    <>
      {!hideParent && (
        <Box
          key={currentPath}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: 0.3,
            flexWrap: { xs: "wrap", lg: "nowrap" },
          }}
        >
          <Box sx={{ display: "flex", gap: 1, flex: "0 0 auto" }}>
            {tabs.map((tab) => (
              <CustomButton
                key={tab.key}
                variant="contained"
                onClick={() => {
                  navigate(tab.key);
                }}
                style={{
                  borderTopRightRadius: "15px",
                  borderTopLeftRadius: "15px",
                  whiteSpace: "nowrap",
                  backgroundColor:
                    currentPath === tab.key ? themecolors.themeLightColor : "#fff",
                  color: currentPath === tab.key ? "#fff" : themecolors.themeLightColor,
                }}
              >
                {translate(tab.label)}
              </CustomButton>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 1,
              marginLeft: "auto",
              flex: "1 1 auto",
              minWidth: 0,
              flexWrap: { xs: "wrap", md: "nowrap" },
            }}
          >
            <TextField
              label={translate("searchSoNumber")}
              value={searchValues.poNumber}
              onChange={(e) => handleSearchValues("poNumber", e)}
              sx={{ flex: "1 1 140px", minWidth: 140, maxWidth: 200 }}
            />
            <TextField
              label={translate("searchSoRefNumber")}
              value={searchValues.poRefNumber}
              onChange={(e) => handleSearchValues("poRefNumber", e)}
              sx={{ flex: "1 1 140px", minWidth: 140, maxWidth: 200 }}
            />
            <CustomButton
              style={{ minWidth: "80px", flexShrink: 0 }}
              onClick={submitSearch}
            >
              {translate("search")}
            </CustomButton>
            {isIndividual &&
              checkPrivileges("deliverynote") &&
              checkPrivileges("porequestCreate") &&
              checkPrivileges("porequestPoInvoiceGenerate") && (
                <CustomButton
                  style={{ minWidth: "110px", flexShrink: 0, whiteSpace: "nowrap" }}
                  onClick={() => navigate("view")}
                >
                  {translate("gen.Invoice")}
                </CustomButton>
              )}
          </Box>
        </Box>
      )}
      <Outlet />
    </>
  );
};

export default MainProcessInvoices;
